import { Box, Typography } from "@mui/material";

const WelcomeBox = ({ user }) => {
    const nameParts = user?.user_display_name?.split(" ") || [];
    const firstPart = nameParts[0] || "";
    const secondPart = nameParts[1] || "";

    return (
        <Box sx={{ px: 2 }}>
            <Typography variant="h6" color="#fff">
                Welcome, {firstPart} {secondPart ? secondPart[0] : ""}
            </Typography>
        </Box>
    );
};

export default WelcomeBox;
